import React from "react";
import { useAuth } from "@/contexts/AuthContext";
import { can } from "@/lib/rbac";
import AccessDenied from "./AccessDenied";

/**
 * RouteGuard — wrap a page with a permission check.
 *
 * Usage:
 *   <RouteGuard surface="govern.policies" label="Policy Catalogue">
 *     <PolicyCatalogue />
 *   </RouteGuard>
 *
 * If the active persona cannot `view:<surface>`, renders <AccessDenied />
 * in-place so the AppShell + sidebar remain visible (the user keeps their
 * context and can navigate away cleanly).
 */
export default function RouteGuard({ surface, label, children }) {
  const { user } = useAuth();
  if (!user) return null;
  if (!can(user.id, `view:${surface}`)) {
    return <AccessDenied surface={surface} surfaceLabel={label} />;
  }
  return children;
}
